import { ItemCategory } from '@planone/bau365/data-access-user';
import { EntityType } from '@planone/bau365/util-fair-data';

export interface ItemType {
  type: EntityType;
  label: string;
  slug: string;
  icon: string;
  placeholderIcon: string;
}

export const itemTypes: ItemType[] = [
  {
    type: EntityType.event,
    label: $localize`:@@featureWatchlist-pageWatchlist-event:Event`,
    slug: 'events',
    icon: 'event',
    placeholderIcon: 'calendar_month',
  },
  {
    type: EntityType.exhibitor,
    label: $localize`:@@featureWatchlist-pageWatchlist-exhibitor:Aussteller`,
    slug: 'exhibitors',
    icon: 'exhibitor',
    placeholderIcon: 'corporate_fare',
  },
  {
    type: EntityType.post,
    label: $localize`:@@featureWatchlist-pageWatchlist-post:Beitrag`,
    slug: 'posts',
    icon: 'post',
    placeholderIcon: 'contract',
  },
  {
    type: EntityType.product,
    label: $localize`:@@featureWatchlist-pageWatchlist-product:Produkt`,
    slug: 'products',
    icon: 'product',
    placeholderIcon: 'package_2',
  },
  {
    type: EntityType.brand,
    label: $localize`:@@featureWatchlist-pageWatchlist-brand:Marke`,
    slug: 'exhibitors',
    icon: 'brand',
    placeholderIcon: 'shoppingmode',
  },
];

export type ItemCategoryOption = {
  category: ItemCategory;
  count: number;
};
